import { Component, OnInit } from "@angular/core";
import { MyAccountService } from "../my-account.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import * as CryptoJS from "crypto-js";
import { environment } from "./../../../environments/environment";
import { SubscriptionService } from "src/app/subscription/subscription.service";

@Component({
  selector: "app-my-subscription",
  templateUrl: "./my-subscription.component.html",
  styleUrls: ["./my-subscription.component.css"],
})
export class MySubscriptionComponent implements OnInit {
  subscriptionData: any = [];
  data: any;
  result: any;
  is_data: any;
  isActive: boolean;
  subscription: any;

  constructor(
    public myAccountService: MyAccountService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private homeService: SubscriptionService
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.myAccountService.subscription().subscribe(
      (res) => {
        if (res) {
          this.spinner.hide();
          this.result = res;
          this.subscriptionHistory();
          if (res.canceled_at != null) {
            this.is_data = "no";
            if (localStorage.getItem(environment.localStorageKey)) {
              const encryptedData = localStorage.getItem(
                environment.localStorageKey
              );
              const userinfo = JSON.parse(
                CryptoJS.AES.decrypt(
                  encryptedData,
                  environment.secretkey
                ).toString(CryptoJS.enc.Utf8)
              );
              userinfo.subscription_type = null;
              const promo = CryptoJS.AES.encrypt(
                JSON.stringify(userinfo),
                environment.secretkey
              ).toString();
              localStorage.setItem(environment.localStorageKey, promo);
              // this.router.navigate(["/subscription"]);
            }
          } else {
            this.is_data = "yes";
          }
        } else {
          this.is_data = "no";
          this.result = {};
          this.spinner.hide();
          this.router.navigate(["/subscription"]);
        }
      },
      (err) => {
        this.subscriptionHistory();
        if (err.error.code == 404) {
          this.spinner.hide();
          // this.router.navigate(["/subscription"]);

          //this.toastr.error(err.error.message, "OOPS!");
        }
        this.is_data = "no";
        //this.toastr.error("Not any subscription yet.", "OOPS!");
        this.spinner.hide();
      }
    );
    this.isActive = true;
    this.subscriptionPlanInfo();
  }
  subscriptionPlanInfo() {
    this.homeService.subscriptionPlanInfo().subscribe(
      (res: any) => {
        this.subscription = res.results;
      },
      (err) => {
        this.toastr.error(err.error.message, "OOPS!", {
          closeButton: true,
        });
      }
    );
  }

  cancelPlane() {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to cancel plan!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it",
      allowOutsideClick: false

    }).then((result) => {
      if (result.value) {
        if (this.result.payment_gateway != "apple") {
          this.spinner.show();
          this.myAccountService
            .cancelPlane(this.result.payment_gateway)
            .subscribe((res) => {
              if (res.canceled_at) {
                this.result = res;
                this.spinner.hide();
                const encryptedData = localStorage.getItem(
                  environment.localStorageKey
                );
                const userinfo = JSON.parse(
                  CryptoJS.AES.decrypt(
                    encryptedData,
                    environment.secretkey
                  ).toString(CryptoJS.enc.Utf8)
                );
                userinfo.subscription_type = null;
                const promo = CryptoJS.AES.encrypt(
                  JSON.stringify(userinfo),
                  environment.secretkey
                ).toString();
                localStorage.setItem(environment.localStorageKey, promo);
                this.router.navigate(["/subscription"]);
                this.toastr.success(this.result.message, "Success!", {
                  closeButton: true,
                });
              } else {
                //this.result = [];
                this.spinner.hide();
                this.toastr.success(this.result.message, "Success!", {
                  closeButton: true,
                });
              }
            });
        } else {
          this.toastr.error(
            "Please cancel our plan using our mobile App",
            "Info!",
            {
              closeButton: true,
            }
          );
        }
        // Swal.fire(
        //   "Deleted!",
        //   "Your imaginary file has been deleted.",
        //   "success"
        // );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //Swal.fire("Cancelled", "Your plan is safe :)", "error");
      }
    });
  }
  subscriptionHistory() {
    this.myAccountService.subscriptionHistory().subscribe(
      (data: any) => {
        this.subscriptionData = data.results;
        this.subscriptionData.map((el) => {
          if (el.plan === this.result?.plan?.id && el.status === "active") {
            if (el.discount_amount) {
              if (
                el.discount_amount - el.amount === 0 ||
                el.discount_amount >= el.amount
              ) {
                this.result.discount_value = "FREE";
              } else {
                this.result.discount_value = el.amount - el.discount_amount;
              }
            }
          }
        });
      },
      (err) => {
        if (err) {
          setTimeout(() => {}, 3000);
        }
      }
    );
  }
  remove() {
    this.isActive = false;
    this.myAccountService.isActive = false;
  }
  ngOnDestroy() {
    Swal.close();
  }
}
